import { Container } from "unstated";
import LocationData from "../../../Assets/Data/maps";
import { getBoundary } from "../Helpers/getBoundary";
import { Marker } from "mapbox-gl";

const initialState = () => ({
  loaded: false,
  map: null,
  data: LocationData,
  markers: []
});

export default class MapStore extends Container {
  state = initialState();

  name = "MapStore";

  init = async map => {
    console.log("initializing MapStore");
    await this.setState({ map, loaded: true });
  };

  setMarkers = async markers => {
    const { map, markers: oldMarkers } = this.state;
    const boundary = getBoundary(markers);

    oldMarkers.forEach(marker => marker.remove());

    await this.setState({
      markers: markers.map(({ long, lat }) =>
        new Marker().setLngLat([long, lat]).addTo(map)
      )
    });

    map.fitBounds(boundary);
  };

  bindStore = store => {
    this.linkedStores[store.name] = store;
  };
}
